import HiddenReadableText from "@cirrus/legacy/app-components/readspeaker/hiddenReadableText/index.jsx"
import BrowserDetecter from "@cirrus/legacy/app-components/utils/browser-detecter.es6"
import classnames from "classnames"
import eventlistener from "eventlistener"
import { get } from "lodash"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "../common-styles/styles.less"
import { verticalAlignValues } from "../constants/index.es6"
import sortableStyles from "../hocs/sortable/sortable-styles.less"

import Html from "./html.jsx"

export default class extends C {
  constructor(props) {
    super(props)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  static displayName = "TableColumn"

  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    verticalAlign: PropTypes.oneOf(verticalAlignValues),
    invalid: PropTypes.bool,
    title: PropTypes.string,
    dataInfoLinkId: PropTypes.string,
    isLastRowColumn: PropTypes.bool,
    style: PropTypes.object,
    dataQa: PropTypes.string
  }

  handleMouseEnter(...args) {
    const { onMouseEnter } = this.props

    onMouseEnter && onMouseEnter(...args)
  }

  handleMouseLeave(...args) {
    const { onMouseLeave } = this.props

    onMouseLeave && onMouseLeave(...args)
  }

  componentDidMount() {
    const { onMouseEnter, onMouseLeave } = this.props

    this.replaceHandler("add", this.handleMouseEnter, "mouseenter")
    this.replaceHandler("add", this.handleMouseLeave, "mouseleave")
  }

  componentWillUnmount() {
    const { onMouseEnter, onMouseLeave } = this.props

    this.replaceHandler("remove", this.handleMouseEnter, "mouseenter")
    this.replaceHandler("remove", this.handleMouseLeave, "mouseleave")
  }

  replaceHandler(action, handler, event) {
    const column = get(this, "_column._element")

    if (column == null) {
      return
    }

    // TODO: rewrite in jsx, but now it works wrong, see here: https://github.com/facebook/react/issues/7135
    eventlistener[action](column, event, handler)
  }

  handleClick(e) {
    const { onClick } = this.props

    onClick && onClick(e)
  }

  render() {
    const {
      children,
      className,
      columnTitle,
      dangerouslySetInnerHTML,
      invalid,
      isLastRowColumn,
      readable,
      title,
      verticalAlign,
    } = this.props

    const columnClass = classnames(
      styles.td,
      sortableStyles.cellInSortedRow,
      className,
      styles[verticalAlign],
      {
        [styles.lastTrTd]: isLastRowColumn,
        [sortableStyles.sortableCellIe]: BrowserDetecter.detectEdgeOrIE(),
        [sortableStyles.cellInSortedRowIe]: BrowserDetecter.detectEdgeOrIE(),
        [styles.invalid]: invalid,
        "readspeaker-readable-area": readable,
      },
    )

    return (
      <Html
        type={this.props.htmlType}
        ref={(column) => (this._column = column)}
        className={columnClass}
        onClick={this.handleClick.bind(this)}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        colSpan={this.props.colSpan}
        rowSpan={this.props.rowSpan}
        title={title}
        {...this.props.dataQa && { "data-qa": this.props.dataQa }}
        data-info-link-id={this.props.dataInfoLinkId}
        style={this.props.style}
        ariaLabel={this.props.ariaLabel}>
        <HiddenReadableText
          text={columnTitle}
          id={this.props.id}
          ariaLabelledby={this.props.ariaLabelledby}
        />
        {children}
      </Html>
    )
  }
}
